import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";

export default class DefinicjeTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this);
        this.renderTrasa = this.renderTrasa.bind(this);
        this.renderPrzystanek = this.renderPrzystanek.bind(this);
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj definicję'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń definicję'}/>
            </div>
        )
    }

    renderTrasa(cell, row) {
        let trasa = this.props.trasy.find(t => t.idTr === cell)
        if (Boolean(trasa)) {
            return (
                <div>
                    <span className={'label label-ebus-primary'}>{trasa.kodTrasy}</span>
                    <span style={{display: 'inline-block', marginLeft: '5px'}}>{trasa.nazTr}</span>
                </div>
            )
        } else return cell
    }

    renderPrzystanek(cell, row) {
        let przystanek = this.props.przystanki.find(p => p.idPr === cell)
        if (Boolean(przystanek)) {
            return (
                <div>
                    <span className={'label label-ebus-default'}>{przystanek.nazMi}</span>
                    <span style={{marginLeft: '8px'}}>{przystanek.nazPr}</span>
                </div>
            )
        } else return cell
    }

    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30, 50],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div className={'bigger_table'}>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idTd' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTr'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderTrasa}
                                       filter={{type: 'SelectFilter', options: this.props.trasyTS, selectText: 'Wybierz',condition: 'eq'}}
                                       formatDataExtra={this.props.trasyTS}
                    >Trasa</TableHeaderColumn>
                    <TableHeaderColumn dataField='km'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Km</TableHeaderColumn>
                    <TableHeaderColumn dataField='czas'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Czas</TableHeaderColumn>
                    <TableHeaderColumn dataField='kol'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Kolej</TableHeaderColumn>
                    <TableHeaderColumn dataField='czasOdPocz'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Czas od pocz.</TableHeaderColumn>
                    <TableHeaderColumn dataField='idPr'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       dataFormat={this.renderPrzystanek}
                                       filter={{type: 'SelectFilter', options: this.props.przystankiTS, selectText: 'Wybierz',condition: 'eq'}}
                                       formatDataExtra={this.props.przystankiTS}
                    >Przystanek</TableHeaderColumn>
                    <TableHeaderColumn dataField='czasOdPoprz'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Czas od poprz.</TableHeaderColumn>
                    <TableHeaderColumn dataField='kmOdPoprz'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Km od poprz.</TableHeaderColumn>
                    <TableHeaderColumn dataField='idPrPoprz'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       dataFormat={this.renderPrzystanek}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Poprzedni przystanek</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTd'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/defiicje/components/DefinicjeTable.js